import React from "react";
import "./Intro.css";
import Screen from "./Screen.js"

export default function Intro() {
  return (
    <div className="App">
    <Screen>
      </Screen>
      
    </div>
  );
}
